import { incrementGlobalLoading, decrementGlobalLoading } from '../actions/GlobalLoading'

export const PRIMARY_ACTION_PATTERNS = [
  /_INDEX_REQUEST$/,
  /_SHOW_REQUEST$/,
  /_CREATE_REQUEST$/,
  /_UPDATE_REQUEST$/,
  /_DESTROY_REQUEST$/
]

export const EXCLUDED_ACTION_PATTERNS = [
  /^BACKGROUND_/,
  /^POLLING_/
]

export const isPrimaryRequestAction = (action) => {
  const { type } = action
  if (!type) return false

  if (EXCLUDED_ACTION_PATTERNS.some((pattern) => pattern.test(type))) {
    return false
  }

  return PRIMARY_ACTION_PATTERNS.some((pattern) => pattern.test(type))
}

export const isPrimaryResponseOrErrorAction = (action) => {
  const { type } = action
  if (!type) return false
  if (EXCLUDED_ACTION_PATTERNS.some((pattern) => pattern.test(type))) {
    return false
  }
  return type.endsWith('_RESPONSE') || type.endsWith('_ERROR')
}

const apiLoadingMiddleware = (store) => (next) => (action) => {
  if (isPrimaryRequestAction(action)) {
    store.dispatch(incrementGlobalLoading())
  }

  if (isPrimaryResponseOrErrorAction(action)) {
    store.dispatch(decrementGlobalLoading())
  }

  return next(action)
}

export default apiLoadingMiddleware
